import { UserGroup } from './account';

export interface IUserRequest {
  id: number;
  status: boolean;
  email: string;
  account: number;
  first_name: string;
  last_name: string;
  phone_country_code: string;
  phone: string;
  groups: string[];
  user_permissions: string[];
  promote_to_account_owner: boolean;
}

export const userGroupOptions = [
  { id: UserGroup.GUEST, name: 'Guest' },
  { id: UserGroup.ADMIN, name: 'Admin' },
  { id: UserGroup.ACCOUNT_MANAGER, name: 'Account Manager' },
];

export const userGroupFilterOptions = [
  { id: '', name: 'All' },
  { id: UserGroup.GUEST, name: 'Guest' },
  { id: UserGroup.ADMIN, name: 'Admin' },
  { id: UserGroup.ACCOUNT_MANAGER, name: 'Account Manager' },
];

export const userStatusFilterOptions = [
  { id: '', name: 'All' },
  { id: 'Active', name: 'Active' },
  { id: 'Inactive', name: 'Inactive' },
  { id: 'Pending', name: 'Pending' },
];

export const userStatusOptions = [
  { id: 'Active', name: 'Active' },
  { id: 'Inactive', name: 'Inactive' },
  { id: 'Pending', name: 'Pending' },
];

export const dropdownSettings: object = {
  singleSelection: false,
  lazyLoading: true,
  classes: 'myclass custom-class',
  labelKey: 'name',
};

export const accountTypeOptions = [
  { id: 'Advertiser', name: 'Advertiser' },
  { id: 'Publisher', name: 'Publisher' },
];
